export default "__VITE_ASSET__597d21e1__"